<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'policies.title' | translate}}
  </div>
  <div class="policies">
    <div [innerHTML]="'policies.controller' | translate"></div>
    <div [innerHTML]="'policies.data' | translate"></div>
    <div [innerHTML]="'policies.purpose' | translate"></div>
    <div [innerHTML]="'policies.legal' | translate"></div>
    <div [innerHTML]="'policies.storage' | translate"></div>
    <div [innerHTML]="'policies.sharing' | translate"></div>
    <div [innerHTML]="'policies.rights' | translate"></div>
    <div [innerHTML]="'policies.retention' | translate"></div>
    <div [innerHTML]="'policies.security' | translate"></div>
    <div [innerHTML]="'policies.contact' | translate"></div>
  </div>
</div>